var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-video absolute w-100 h-100 flex" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.videoStarted,
            expression: "!videoStarted"
          }
        ],
        staticClass: "gallery-video absolute w-100 h-100",
        on: { click: _vm.initVideo }
      },
      [
        _c("i", { staticClass: "material-icons absolute" }, [
          _vm._v("play_circle_outline")
        ])
      ]
    ),
    _vm._v(" "),
    _vm.videoStarted
      ? _c(
          "div",
          { staticClass: "iframe-wrapper absolute w-100" },
          [
            !_vm.iframeLoaded ? _c("LoaderScoped") : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "iframe-container w-100" }, [
              _c("iframe", {
                staticClass: "absolute w-100 h-100",
                attrs: {
                  src: _vm.embedUrl,
                  allow:
                    "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                  webkitallowfullscreen: "",
                  mozallowfullscreen: "",
                  allowfullscreen: ""
                },
                on: {
                  load: function($event) {
                    return _vm.iframeIsLoaded()
                  }
                }
              })
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }